// Up to two uppercase initials, skipping words that don't start with a letter
// (e.g. "(Jackie)" or "-"). Returns '' for a missing or blank name.
export const initialsOf = (name?: string | null) =>
  (name ?? '')
    .split(/\s+/)
    .filter((word) => /^\p{L}/u.test(word))
    .map((word) => [...word.toUpperCase()][0])
    .slice(0, 2)
    .join('');
